/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MyContext } from '../Context/MyProvider';
import { showToast } from '../showTost';

const PaymentResponse = () => {
    const {
        ApiBaseUrl,
        setIsPayment,
        setActivePage,
        setPaymentStatus
    } = useContext(MyContext);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const processPaymentResponse = async () => {
            const queryParams = new URLSearchParams(location.search);
            const status = queryParams.get('status');
            const transactionId = queryParams.get('transactionId');

            if (status !== "true") {
                setPaymentStatus("PaymentFaild");
                clearSession();
                navigate("/");
                return;
            }

            const PaymentID = sessionStorage.getItem("Paymentid");
            const PaymentData = sessionStorage.getItem("PaymentData");
            const Page = sessionStorage.getItem("page");

            if (!PaymentData) return;

            let PayData = JSON.parse(PaymentData);

            if (PaymentID === "9") {
                try {
                    const url = `${ApiBaseUrl}/customer/get-payfast-transactionid`;
                    const response = await axios.post(url, { transactionId });
                    const { trsansactionId } = response.data;

                    if (trsansactionId) {
                        PayData = { ...PayData, transactionId: trsansactionId };
                        handleBooking(Page, PayData);
                    }
                } catch (error) {
                    console.error("get-payfast-transactionid error:", error);
                }
            } else {
                PayData = { ...PayData, transactionId };
                handleBooking(Page, PayData);
            }
        };

        processPaymentResponse();
    }, [location.search]);

    const handleBooking = (page, data) => {
        switch (page) {
            case "1":
                handleBookAppointment(data);
                break;
            case "2":
                handleBookLab(data);
                break;
            case "3":
                handleOrderBook(data);
                break;
            default:
                console.warn("Unknown page value:", page);
        }
    };

    const handleBookAppointment = async (data) => {
        try {
            const res = await axios.post(`${ApiBaseUrl}/customer/book_appointment`, data);
            // console.log("book_appointment:", res);
            sessionStorage.setItem("Bookid", res.data.appointment_id);
            clearSession();
            navigate("/");
        } catch (error) {
            console.error("book_appointment error:", error);
        }
    };

    const handleBookLab = async (data) => {
        try {
            const res = await axios.post(`${ApiBaseUrl}/customer/add_lab_book`, data);
            const { message, ResponseCode } = res.data;

            if (ResponseCode === 200) {
                setIsPayment(false);
                showToast({ title: message, id: "success" });
                navigate("/dashbord/booking-package");
                setActivePage(3);
                clearSession();
            }
        } catch (error) {
            console.error("add_lab_book error:", error);
        }
    };

    const handleOrderBook = async (data) => {
        try {
            const res = await axios.post(`${ApiBaseUrl}/customer/add_product_order`, data);

            if (res.data.ResponseCode === 200) {
                showToast({ title: res.data.message, id: "success" });
                navigate("/dashbord/order");
                setActivePage(2);
                clearSession();
            }
        } catch (error) {
            console.error("add_product_order error:", error);
        }
    };

    const clearSession = () => {
        sessionStorage.removeItem("PaymentData");
        sessionStorage.removeItem("Paymentid");
    };

    return null;
};

export default PaymentResponse;
/* jshint ignore:end */
